import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import {
    Grid,
    Button,
    CircularProgress,
    colors,
    Modal, Box,
    Tooltip
} from '@material-ui/core';

import { PageContext } from '../PageContext';
import { UserContext } from '../../../contexts/UserContext';

import { ApplicationRoles } from '../../../../helpers';

import ClearIcon from '@material-ui/icons/Clear';

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
      fontSize: "1rem",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      textDecoration: "underline"
    },
    filter: {
      borderRadius: "4px",
      border: "1px solid var(--ag-border-color, #babfc7)",
      background: "var(--ag-header-background-color, #f8f8f8)",
      textAlign: "center",
      margin: "15px 0 0 15px",
      padding: "5px 10px",
      position: 'relative'
    },
    filterNotShow: {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      border: "unset"
    },
    clearIcon: {
      verticalAlign: "bottom",
      '&:hover': {
        backgroundColor: "#f5f2f0",
        cursor: "pointer"
      }
    },
    key: {
      fontSize: "1rem",
      fontWeight: 700
    },
    value: {
      fontSize: "1rem",
      margin: "10px"
    },
    filtersContainer: {
      display: "flex",
      flexWrap: "wrap"
    },
    buttonOverlay: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: 100,
      backgroundColor: "transparent"
    },
    show: {
      display: "block"
    },
    notShow: {
      display: "none"
    }
}));

const dateOption = { month: 'long', day: '2-digit', year: "numeric" };
export const Filters = ({...props }) => {
    const classes = useStyles();

    const {
      isUserInRoles
    } = useContext(UserContext);

    const {
      state,
      setFilter,
      gridApi,
      isBusy
    } = useContext(PageContext);

    const getFilter = (key) => {
      let result = "";
      // DATE
      let newDateTo;
      let newDateTo1;
      let newDateTo2;
      let newDateFrom1;
      let newDateFrom2;

      // NUMBER
      let From;
      let To;
      let To1;
      let To2;
      let From1;
      let From2;

      const filter = state.filterModel[key];
      
      if(filter.filterType === "date")
      {
        if(filter.condition1 && filter.condition2)
        {
          let c1 = filter.condition1;
          let c2 = filter.condition2;
          if((c1 && c1.type === "inRange") && (c2 && c2.type !== "inRange"))
          {
            newDateTo1 = convertDate(c1.dateTo);
            newDateFrom1 = convertDate(c1.dateFrom);

            newDateFrom2 = convertDate(c2.dateFrom);

            result += `${ c1.type } FROM ${ newDateFrom1 } TO ${ newDateTo1 }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } ${ newDateFrom2 }`;
          } else if((c1 && c1.type !== "inRange") && (c2 && c2.type === "inRange"))
          {
            newDateFrom1 = convertDate(c1.dateFrom);
            
            newDateTo2 = convertDate(c2.dateTo);
            newDateFrom2 = convertDate(c2.dateFrom);
            
            result += `${ c1.type } ${ newDateFrom1 }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } FROM ${ newDateFrom2 } TO ${ newDateTo2 }`;
          } else if ((c1 && c1.type === "inRange") && (c2 && c2.type === "inRange")) {
            newDateTo1 = convertDate(c1.dateTo);
            newDateFrom1 = convertDate(c1.dateFrom);
            
            newDateTo2 = convertDate(c2.dateTo);
            newDateFrom2 = convertDate(c2.dateFrom);
            
            result += `${ c1.type } FROM ${ newDateFrom1 } TO ${ newDateTo1 }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } FROM ${ newDateFrom2 } TO ${ newDateTo2 }`;
          } else {
            let newDateFrom1 = convertDate(filter.condition1.dateFrom);
            let newDateFrom2 = convertDate(filter.condition2.dateFrom);

            result += `${ c1.type } ${ newDateFrom1 }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } ${ newDateFrom2 }`;
          }
        } else {
          const newDateFrom = convertDate(filter.dateFrom);
          if(filter.dateTo && filter.type === "inRange")
          {
            newDateTo = convertDate(filter.dateTo);
            result += `${ filter.type } FROM ${ newDateFrom } TO ${ newDateTo }`;
          } else {
            result += `${ filter.type } ${ newDateFrom }`;
          }
        }
      }
      else if(filter.filterType === "number") {
        if(filter.condition1 && filter.condition2)
        {
          let c1 = filter.condition1;
          let c2 = filter.condition2;
          if((c1 && c1.type === "inRange") && (c2 && c2.type !== "inRange"))
          {
            result += `${ c1.type } FROM ${ c1.filter } TO ${ c1.filterTo }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } ${ c2.filter }`;
          } else if((c1 && c1.type !== "inRange") && (c2 && c2.type === "inRange"))
          {
            result += `${ c1.type } ${ c1.filter }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } FROM ${ c2.filter } TO ${ c2.filterTo }`;
          } else if ((c1 && c1.type === "inRange") && (c2 && c2.type === "inRange")) {
            result += `${ c1.type } FROM ${ c1.filter } TO ${ c1.filterTo }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } FROM ${ c2.filter } TO ${ c2.filterTo }`;
          } else {
            result += `${ c1.type } ${ c1.filter }`;
            result += ` ${ filter.operator } `;
            result += `${ c2.type } ${ c1.filter }`;
          }
        } else {
          if(filter.type === "inRange")
          {
            result += `${ filter.type } FROM ${ filter.filter } TO ${ filter.filterTo }`;
          } else {
            result += `${ filter.type } ${ filter.filter }`;
          }
        }
      } else {
        if(filter.condition1 && filter.condition2)
        {
          result += `${ filter.condition1.type} ${ filter.condition1.filter } ${ filter.operator} ${ filter.condition2.type } ${ filter.condition2.filter }`;
        } else {
          result += `${ filter.type } ${ filter.filter }`;
        }
      }

      return result;
    }

    const convertDate = (date) => {
      let onlyDate = date.split(" ")[0];
      onlyDate = onlyDate.split("-");

      return new Date(onlyDate[0], (parseInt(onlyDate[1])-1).toString(), onlyDate[2]).toLocaleDateString('en-US', dateOption).replace(",", "");
    }

    const clearFilter = (key) => {
      delete state.filterModel[key];
      gridApi.setFilterModel(state.filterModel);
      setFilter(state.filterModel);
    }

    return (
        <Grid container className={clsx(classes.root, props.className)} justifyContent="space-between">
            <Grid item>
                {
                  (isUserInRoles([ApplicationRoles.Administrator, ApplicationRoles.Editor]) && state.filterModel && Object.keys(state.filterModel).length !== 0) &&
                  <>
                    <div className={ classes.title }>Applied filters</div>
                    <div className={ classes.filtersContainer }>
                      {
                        Object.keys(state.filterModel).map((key) => {
                          return <div className={ clsx(classes.filter, isBusy() ? classes.filterNotShow : "") }>
                                    <span className={ classes.key }>{ key }:</span> <span className={ classes.value }>{ getFilter(key) }</span> 
                                    <Tooltip title="Clear this filter" arrow placement="right"><ClearIcon onClick={ () => { clearFilter(key) } } className={ classes.clearIcon } /></Tooltip>
                                    <div className={ clsx(classes.buttonOverlay, isBusy() ? classes.show : classes.notShow) }></div>
                                  </div>
                        })
                      }
                    </div>
                  </>
                }
            </Grid>
        </Grid >
    );
}